import { getDate } from '@ixicare/resources';
import { format } from 'date-fns';

export function downloadAsBlob(name: string, value: string) {
  const blob = new Blob([value], {
    type: 'text/csv;charset=utf-8',
  });

  const data = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = data;
  link.download = name;

  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );

  setTimeout(() => {
    window.URL.revokeObjectURL(data);
    link.remove();
  }, 100);
}

export const formatDateTimeExport = (date: string | Date) =>
  format(typeof date === 'string' ? getDate(date) : date, 'dd/MM/yyyy HH:mm');
